import * as React from 'react';
import type { SVGProps } from 'react';
import { chakra } from '@chakra-ui/react';
const SvgIconGarage = chakra((props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={26}
    height={21}
    fill="none"
    viewBox="0 0 26 21"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="#fff"
      fillOpacity={0.6}
      d="M20.188 8.5c.859 0 1.562.703 1.562 1.563v10c0 .546-.43.937-.938.937-.546 0-.937-.39-.937-.938v-9.687H6.125v9.688c0 .546-.43.937-.938.937-.546 0-.937-.39-.937-.938v-10c0-.859.664-1.562 1.563-1.562h14.375Zm-2.891 6.25a2.412 2.412 0 0 1 1.328 2.148v.625c0 .547-.273 1.055-.625 1.407v1.133c0 .546-.43.937-.938.937-.546 0-.937-.39-.937-.938v-.625h-6.25v.625c0 .547-.43.938-.938.938-.546 0-.937-.39-.937-.938V18.93a1.891 1.891 0 0 1-.625-1.407v-.625c0-.937.508-1.757 1.29-2.148l.624-1.914c.313-.899 1.133-1.524 2.11-1.524h3.164c.976 0 1.796.626 2.109 1.524l.625 1.914Zm-6.211-1.328-.352 1.015h4.493l-.352-1.015a.34.34 0 0 0-.313-.235h-3.164a.34.34 0 0 0-.312.235Zm5.664 4.101v-.625a.6.6 0 0 0-.586-.585H9.797c-.313 0-.547.273-.547.585v.625l7.422.04c.039 0 .078 0 .078-.04Zm7.07-12.187a2.627 2.627 0 0 1 1.68 2.46v12.267c0 .546-.43.937-.938.937-.546 0-.937-.39-.937-.938V7.797a.764.764 0 0 0-.508-.742l-9.844-4.102a.762.762 0 0 0-.585 0L2.844 7.055c-.313.117-.469.43-.469.742v12.265c0 .547-.43.938-.938.938-.546 0-.937-.39-.937-.938V7.797a2.538 2.538 0 0 1 1.64-2.461l9.805-4.102a2.715 2.715 0 0 1 2.07 0l9.805 4.102Z"
    />
  </svg>
));
export default SvgIconGarage;
